import { useState } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import {
  BroadcastsListStore,
  type IBroadcastsListStoreProps,
} from 'pages/broadcasts/ui/BroacastList/store/broadcastsListStore'
import { BroadcastsListContext } from '../context/context'
import { BroadcastListContent } from './BroadcastListContent'

type IBroadcastListProps = {
  storeProps: IBroadcastsListStoreProps
}

export const BroadcastList = ({ storeProps }: IBroadcastListProps) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new BroadcastsListStore(storeProps, entities))

  return (
    <BroadcastsListContext.Provider value={store}>
      <BroadcastListContent />
    </BroadcastsListContext.Provider>
  )
}
